module.exports = __webpack_public_path__ + "media/2.1_comparative_superiority_silvia_cf1.fa2260e9.wav";